<template>
  <li v-if="routerName" class="list-item" :class="[variant,{'is-disabled': disabled}]">
    <router-link
      v-if="params"
      :to="{ name: routerName, params: params, query: query }"
      :target="target"
      :disabled="disabled"
      class="atag"
    >
      <slot></slot>
    </router-link>
    <router-link
      v-else
      :to="{ name: routerName, hash: hash, query: query }"
      :target="target"
      :disabled="disabled"
      class="atag"
    >
      <slot></slot>
    </router-link>
  </li>
  <li v-else-if="href" class="list-item" :class="[variant,{'is-disabled': disabled}]">
    <a
      :href="href"
      class="btn-main atag"
      :target="target"
      @click="clickHandler"
    >
      <slot></slot>
    </a>
  </li>
  <li v-else class="list-item" :class="[variant]">
    <slot></slot>
  </li>
</template>

<script>
export default {
  name: "ListItem",
  props: {
    variant: { type: String, default: "" },
    link: { type: String, default: "" },
    routerName: { type: String, default: "" },
    href: { type: String, default: "" },
    hash: { type: String, default: "" },
    target: { type: String, default: "" },
    params: { type: Object, default: () => {} },
    query: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
  },
  emits: ["click"],
  methods: {
    clickHandler: function (e) {
      this.$emit("click", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.list-item {
  @include mq-up(md) {
    font-size: 16px;
    line-height: 24px;
  }
  &.unread {
    font-weight: bold;
  }
  &.bold {
    font-weight: bold;
  }
  &.-link {
    text-align: left;
    &:first-child {
      border-top: $secondary dotted 1px;
    }
    background-image: url("@/assets/images/icons/arrow-right-gray.svg");
    background-position: right 0px center;
    background-repeat: no-repeat;
    background-size: 8px 14px;
    list-style-type: none;
    border-bottom: $secondary dotted 1px;
    > .atag {
      display: block;
      font-size: 14px;
      line-height: 20px;
      padding: 20px 20px 20px 0px;
      color: $black;
      width: 100%;
      &:hover {
        color: $primary;
        text-decoration: underline;
      }
      @include mq-up(md) {
        font-size: 16px;
        line-height: 24px;
        padding: 25px 25px 25px 0px;
      }

    }
  }
  &.is-disabled {
    &.-link {
      opacity: 0.5;
    }
    > .atag {
      cursor: not-allowed;
      pointer-events: none;
      &:hover {
        color: $black;
        text-decoration: none;
      }
    }
  }
}

.list-group {
  &.-visited {
    > .list-item {
      > .atag {
        &:visited {
          color: $visited;
        }
      }
    }
  }
}

//よくある質問カード内のリストアイテム
.card-box.-faq {
  > .card-body {
    > .list-group {
      > .list-item {
        .atag {
          background-image: url("@/assets/images/icons/Q.svg");
          background-repeat: no-repeat;
          background-size: 18px 20px;
          background-position: 0 50%;
          padding-left: 30px;
        }
        @include mq-down() {
          width: 100%;
        }
        @include mq-up() {
          width: calc(50% - 20px);
          &:nth-of-type(2) {
            border-top: $secondary dotted 1px;
          }
        }
      }
    }
  }
}
</style>
